import axios from 'axios';
import { useEffect, useState } from 'react';

export const useCheckLocation = (
  locationName: string,
  lat: string,
  long: string
) => {
  const [dataLat, setDataLat] = useState<string>();
  const [dataLong, setDataLong] = useState<string>();
  const [dataLocationName, setDataLocationName] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setDataLat(lat);
    setDataLong(long);
    setDataLocationName(locationName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationName]);

  useEffect(() => {
    handleLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataLat, dataLong]);

  const handleLocation = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse`,
        {
          params: {
            format: 'json',
            lat: dataLat,
            lon: dataLong,
            zoom: 8,
            'accept-language': 'en'
          }
        }
      );
      setIsLoading(false);
      setDataLocationName(
        !response.data.error ? response.data.display_name : 'Unknown'
      );
    } catch (error) {
      setIsLoading(false);
      setDataLocationName('');
    }
  };

  return { setDataLat, setDataLong, isLoading, dataLocationName };
};
